export default "__VITE_ASSET__9c49eaee__"